<template>
	<Container>
		<TopBar/>
			<div class="content">
				<div class="item" :key='index' v-for='(item,index) in category'>
					<div class="img-box zoom-out" @click='cellClicked(item)'>
						<img v-lazysrc="item.Pic" :data-default='require("@/assets/defaultImg.png")'>
					</div>
					<p class="category-name"><span @click='cellClicked(item)'>{{item.Name}}(<span class="num">{{item.Nums || item.Posts}}</span>)</span></p>
				</div>
			</div>
		</div>
	</Container>
</template>

<script>
	import TopBar from '@/components/common/TopBar'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				category:[],
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{
			'$route'(value){
				let code = value.query?.code
				this.initData(code)
			},
		},
		mixins:[],
		components: {
			TopBar,
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getCommunityCatalogAction',
			]),
			async initData(code){
				code = code || this.$route.query?.code || 'DT_WS_CommunityCatalog'
				let response = await this.getCommunityCatalogAction(code)
				this.category = response;
			},
			cellClicked(item) {
				if (item.Href) {
					location = item.Href
					return
				}
				if (item.Nums) {
					this.$router.push({
						path:'/community/category',
						query:{
							code:item.Code,
						}
					})
				} else {
					this.$router.push({
						path:'/community/article',
						query:{
							code:item.Code,
						}
					})
				}
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.content {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin: 0 10.42vw;
		margin-bottom: 40px;
		.item {
			width: 37.5vw;
			margin-top: 40px;
			.img-box {
				width:100%;
				height:23.44vw;
				border-radius: 20px;
				overflow: hidden;
				cursor: pointer;
			}
			img {
				width: 100%;
				height:100%;
				object-fit: cover;
			}
			.category-name {
				text-align: center;
				margin-top: 2.6vw;
				@include fontSize($font-size-20);
				span {
					cursor: pointer;
				}
				.num {
					color:$theme-color;
				}
			}
		}
	}
	@media (max-width: 768px){
		.content {
			margin: 0 auto;
			width: 95vw;
			.item {
				width: 45vw;
				.img-box {
					height:28.2vw;
				}
			}
		}
		
	}
</style>